import { TState } from '@r1-frontend/entities/stores/auth/reducer';

export const selectAccessToken = (state: TState) => {
    return state.auth.accessToken;
};

export const selectHasAuthorization = (state: TState) => {
    return !!state.auth.accessToken;
};
